import React from 'react';
import './TitleSubtitle.css';

const TitleSubtitle = ({ titleText, subtitleText }) => {
    return (
        <div className="title-container">
            <h1 className="service-title">{titleText}</h1>
            <div className="subtitle-container">
                <h2 className="service-subtitle">{subtitleText}</h2>
            </div>
        </div>
    );
};

export default TitleSubtitle;
